import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useDispatch } from 'react-redux';

import { downloadDoc } from '../../../../services/documentsService';

import { PDF, POPUP } from '../../../../../redux/types';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import Icon from '../../../../ui/icon/icon';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './mobileNameCell.scss';

const MobileNameCell: React.FC<IDocumentsCell> = ({ dataItem, idField, field, width }) => {
  const [isRead, setIsRead] = useState<boolean>(dataItem.isRead);

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useInternationalization();

  const navigateToBoard = (investorId: number, boardId: number): void => {
    navigate(`/boards/${investorId}/${boardId}`);
  };

  if (dataItem[field] === undefined) return <LoadingCell />;

  const updateIsReadFlag = (isRead) => {
    setIsRead(isRead);
    dataItem.isRead = isRead;
  };

  useEffect(() => {
    setIsRead(dataItem.isRead);
  }, [isRead]);

  return dataItem.type === 'board' ? (
    <td className='mobile-name-cell' style={{ width: width }}>
      <div className='mobile-name-wrapper'>
        <Icon name='fal fa-tachometer-alt-average' className='document-icon' />
        <div className='mobile-name-cell'>
          <span onClick={() => navigateToBoard(dataItem.objectId, dataItem.contentId)}>{dataItem[field]}</span>
          <div className='date-info'>{intl.formatDate(new Date(dataItem['publishDate']), 'd')}</div>
        </div>
      </div>
    </td>
  ) : (
    <td className='mobile-name-cell' style={{ width: width }}>
      <div className='mobile-name-wrapper'>
        <Icon name='fal fa-file-chart-line' className='document-icon' />
        {dataItem.fileType && dataItem.fileType.toLowerCase() === 'pdf' ? (
          <div className='mobile-name-cell' onClick={() => dispatch({ type: PDF.SHOW_PDF_DIALOG, payload: dataItem[idField || 'id']})}>
              <span
                style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                onClick={() => {
                  updateIsReadFlag(true);
                }}>
                {dataItem[field]}
              </span>
            <div className='date-info'>{intl.formatDate(new Date(dataItem['publishDate']), 'd')}</div>
          </div>
        ) : (
          <div className='mobile-name-cell'>
              <span style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                    onClick={() => downloadDoc(dataItem).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }))}>
                {dataItem[field]}
              </span>
            <div className='date-info'>{intl.formatDate(new Date(dataItem['publishDate']), 'd')}</div>
          </div>
        )}
      </div>
    </td>
  );
};

export default MobileNameCell;
